var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSend = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 3.79352C0 2.7118 1.1102 1.98571 2.10123 2.41929L22.4294 11.3129C23.0286 11.575 23.0286 12.425 22.4294 12.6871L2.10123 21.5807C1.1102 22.0143 0 21.2882 0 20.2065V14.25C0 13.4216 0.671573 12.75 1.5 12.75H12.75C13.1642 12.75 13.5 12.4142 13.5 12V12C13.5 11.5858 13.1642 11.25 12.75 11.25H1.5C0.671573 11.25 0 10.5784 0 9.75V3.79352Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSend);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/send.c563e1a7a76b8c56c51b5a5560b4d6d2.svg";